export default "__VITE_ASSET__CG5oBLt___"